import React from "react";
import "../../styles/mywork.css";
import Banner from "../banner/Banner";
import Project from "./Project";
export default function Mywork() {
  return (
    <div>
      <Banner />
      <div className="mywork">
        <div className="intro">
          <h1>My Work</h1>
          <h3>Here lies all projects and work</h3>
        </div>
        <div className="content">
          <Project
            name={"Document Database"}
            url={"https://humanrightsfirst.org/"}
            image={require("../../media/human-rights-first-db.png")}
            description={
              "Document Database, allows you to search all documents to look for international atrocities before governments delete them. "
            }
          />
          <Project
            name={"Coder Heroes"}
            url={"https://www.coderheroes.com"}
            image={require("../../media/coder-heroes.png")}
            description={
              "Website built to help a non profit teach young kids how to code.  "
            }
          />
          <Project
            name={"The Quadrant Shop"}
            url={"https://www.thequadrantshop.com/"}
            image={require("../../media/the-quadrant-shop.png")}
            description={
              "website to host courses for individuals and companies to learn industrial insulation"
            }
          />
          <Project
            name={"calculator"}
            url={"https://calculator-jonah.vercel.app/"}
            image={require("../../media/calculator.png")}
            description={
              "Calculator built in complete React.js, no calculation from outside packages."
            }
          />
          <Project
            name={"Nasa Photo of The Day"}
            url={"https://nasaspaceblogging.netlify.app"}
            image={require("../../media/nasaphoto.png")}
            description={
              "Using nasa's daily API, each day there is a new beautiful space photo every day."
            }
          />

          <Project
            name={"This portfolio website"}
            image={require("../../media/portfolio-website.png")}
            description={"Created by me, styled by me, deployed by netlify."}
          />
        </div>
      </div>
    </div>
  );
}
